import { combineReducers } from 'redux';
import customizer from './customizer/';
import auth from './auth/';
import users from './users/users';
import profile from './profile/profile';
import customers from './customers/customers';
import toastReducer from './toastReducer/toastReducer';
import { reducer as reduxFormReducer } from 'redux-form';

const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  users: users,
  toast: toastReducer,
  profile: profile,
  customers: customers,
  form: reduxFormReducer, // mounted under "form"
});

export default rootReducer;
